<form [formGroup]="formGroup">
    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field [type]="fields.email.type" [options]="fields.email.options"></app-form-field>
    <app-form-field [type]="fields.rolName.type" [options]="fields.rolName.options"></app-form-field>
	<app-form-field [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
    <p-inputSwitch *ngIf="isEdit" (onChange)="setValidatorsForPassword($event)" formControlName="changePassword"></p-inputSwitch>
    <ng-container *ngIf="changePassword">
        <app-form-field [type]="fields.password.type" [options]="fields.password.options"></app-form-field>
        <app-form-field [type]="fields.confirmPassword.type" [options]="fields.confirmPassword.options"></app-form-field>
    </ng-container>
    
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
